import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../../helpers/EventEmitter'
import { Input } from '../../../library/common/html/input'
import { UseI18n } from '../../hooks/useI18n'
import { Element } from '../../html/element'
import { PopupAction } from '../PopupAction'
import {
  clearValidateNameCreatePortfolio,
  selectPortfolios,
  selectTextValidateNamePortfolio,
} from './store/slice'
import { getPortfolioByOrgId, postCreatePortfolio } from './store/thunk'

export const CreatePortfolio = ({ organizationId }) => {
  const dispatch = useDispatch()

  const textValidate = useSelector(selectTextValidateNamePortfolio)
  const portfolios = useSelector(selectPortfolios)
  const textValidateMaxRecord = UseI18n('library.main.VALIDATE_PORTFOLIO')

  const [isShow, setIsShow] = useState(false)
  const [value, setValue] = useState('')

  const handleShow = () => {
    if (portfolios.length >= 300) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [textValidateMaxRecord],
      })
      return null
    }
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const handleCreateNewPortfolio = () => {
    dispatch(
      postCreatePortfolio({
        portfolioName: value.trim(),
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(getPortfolioByOrgId({ OrganizationId: organizationId }))
        handleClose()
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (textValidate) {
      dispatch(clearValidateNameCreatePortfolio())
    }
  }, [value])

  return (
    <>
      <Element
        elementName="p"
        style={{ color: '#2C73E8', paddingLeft: 12 }}
        onClick={handleShow}
      >
        <Translate value="library.savePortfolio.CREATE_NEW_PORTFOLIO" />
      </Element>
      {isShow && (
        <PopupAction
          appendStyle={{
            padding: '20px',
            backgroundColor: '#F3F3F3',
            width: 480,
            borderRadius: '4px',
          }}
          isShow={isShow}
          title="library.savePortfolio.CREATE_NEW_PORTFOLIO"
          handleClose={handleClose}
          btnSubmit={{
            label: 'library.main.CREATE',
            isI18n: true,
            event: () => {
              handleCreateNewPortfolio()
            },
            disabled: !value.trim(),
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: handleClose,
            isI18n: true,
          }}
        >
          <Input
            placeHolder="library.savePortfolio.ENTER_NAME_PORTFOLIO"
            onChange={setValue}
            onEnter={() => {
              handleCreateNewPortfolio()
            }}
            isRemoveSpecialCharacters={true}
            value={value}
          />
          {textValidate && (
            <>
              <Element
                elementName="p"
                style={{
                  fontStyle: 'italic',
                  color: '#E0505B',
                  paddingTop: 4,
                }}
              >
                {textValidate}
              </Element>
            </>
          )}
        </PopupAction>
      )}
    </>
  )
}
